export default "__VITE_ASSET__DDIbGtGI__"